function dataURLtoBlob(dataurl, encode = false) {
  const arr = dataurl.split(','); const mime = arr[0].match(/:(.*?)$/)[1];
  let bstr = dataurl.substring(dataurl.indexOf(',') + 1);
  if (encode) {
    bstr = atob(bstr);

    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n) {
      u8arr[n] = bstr.charCodeAt(n);
      n -= 1;
    }

    return new Blob([u8arr], { type: mime });
  }

  return new Blob([bstr], { type: mime });
}

export const downloadAsFile = (content, fileName, encode = true) => {
  // detect whether the browser is IE/Edge or another browser
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // To IE or Edge browser, using msSaveorOpenBlob method to download file.
    const blobObject = dataURLtoBlob(content, encode);
    window.navigator.msSaveOrOpenBlob(blobObject, fileName);
  } else {
    const csvBlob = new Blob([content], { type: 'text/csv' });
    // To another browser, create a tag to downlad file.
    const link = document.createElement('a');
    link.setAttribute('href', window.URL.createObjectURL(csvBlob));
    link.setAttribute('download', fileName);
    document.body.appendChild(link); // Required for FF

    link.click();
    link.remove();
  }
};
